<template>
    <div class="appVersion">
        <div>
            <form :form="form" @submit.prevent="query">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                  <div class="logQuery">
                    <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:30%" label="登录账号" type="text" id="code" v-model="form.code" placeholder="请输入登录账号"/>
                    <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;width:30%" label="姓名" type="text" id="name" v-model="form.name" placeholder="请输入姓名"/>
                    <a-space style="margin: 0 0 0 0.5rem">
                        <ButtonField text="查询" @click="query" secondary />
                        <ButtonField text="重置" primary @click="reset"/>
                    </a-space>
                  </div>
                  <div class="right">
                      <ButtonField text="新增" primary @click="add"/>
                  </div>
                </div>
            </form>
        </div>
        <div>
            <Tablelist :showCheckbox="false" :list="list" :columns="tableColumns">
                <template #template-sex="{ item }">
                    <DataDictFinder dictType="gender" :dictValue="item.sex" />
                </template>
                <template #template-sex="{ item }">
                    {{ Array.isArray(item.roles) ? item.roles.map((item1) => item1.name).join(",") : "--" }}
                </template>
                <template #template-status="{ item }">
                    <DataDictFinder dictType="status" :dictValue="String(item.status)" />
                </template>
                <template v-slot:actions="{ item }">
                    <a-space>
                        <a href="#" @click.prevent="editText(item)">编辑</a>
                        <a href="#" @click.prevent="deleteText(item)" class="danger">停用</a>
                        <a href="#" @click.prevent="resetPassword(item)" class="danger">重置密码</a>
                    </a-space>
                </template>
            </Tablelist>
        </div>
        <Modal v-if="visible" v-model="visible"
               contentWidth="800px"
               :visible="visible" :title="addShow ? '新增用户' :'编辑用户'" :showFooter="false" :overlayOpacity="0.5" @update:visible="visible = $event">
          <AddIndex v-if="addShow && visible" @close="cancel"/>
          <EditIndex v-if="editShow && visible" :id="editId" @close="cancel"/>
        </Modal>
    </div>
</template>

<script>
import { fetchList, remove, resetUserPassword } from "@/api/setting/user";
import AddIndex from "./add.vue";
import EditIndex from "./edit.vue";
export default {
  components: {AddIndex,EditIndex},
  data() {
    return {
      form: {},
      loading: false,
      current: 1,
      pageSize: 10,
      list: [
          {
          id: 1,
          code: 'user1',
          name: '张三',
          sex: 'male',
          mobile: '12345678901',
          roles: [
              { name: '管理员' },
              { name: '编辑' }
          ],
          status: 1
      },
          {
              id: 2,
              code: 'user2',
              name: '李四',
              sex: 'female',
              mobile: '12345678902',
              roles: [
                  { name: '普通用户' }
              ],
              status: 0
          }],
      total: 0,
      visible: false,
      editingText: {},
      tableColumns: [
          {
              key: 'code',
              title: '登录账号',
              field: 'code',
              infotype: 'text'
          },
          {
              key: 'name',
              title: '姓名',
              field: 'name',
              infotype: 'text'
          },
          {
              key: 'sex',
              title: '性别',
              field: 'sex',
              infotype: 'template',
          },
          {
              key: 'mobile',
              title: '手机号',
              field: 'mobile',
              infotype: 'text',
          },
          {
              key: 'role',
              title: '角色',
              field: 'role',
              infotype: 'template'
          },
          {
              key: 'status',
              title: '状态',
              field: 'status',
              infotype: 'template',
          },
          {
              key: 'actions',
              title: '操作',
              infotype: 'template'
          }
      ],
      addShow:false,
      editShow:false,
      editId:''
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
      cancel(){
          this.editShow = false;
          this.addShow = false;
          this.visible = false;
      },
      add(){
          this.addShow = true;
          this.editShow = false;
          this.visible = true;
      },
      editText(text){
          console.log("text:::",text)
          this.editId = text.id
          this.editShow = true;
          this.addShow = false;
          this.visible = true;
      },
    getList() {
      this.loading = true;
      fetchList({
        pageNum: this.current,
        pageSize: this.pageSize,
        ...this.form,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确定要删除吗？",
        onOk() {
          remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
    resetPassword(text) {
      let that = this
      this.$confirm({
        title: "确定要重置密码么？",

        onOk() {
          console.log('onResetPassword', text)
          resetUserPassword({
            id: text.id
          }).then(() => {
            that.$message.success("密码重置成功！");
          }).catch((error) => {
            console.log(error)
          })
          // 需补充接口调用，以及异常处理

          // 此处需要补充接口
          /*remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
          */
        },
      });
    },
    onChange(pagination) {
      this.current = pagination.current;
      this.getList();
    },
    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },
  },
};
</script>
<style scoped>
.logQuery{
    display: flex;
    justify-content: start;
    width: 70%;
}
::v-deep .input-container{
    padding: 0;
}
</style>